import Component from '../core/Component'
import CourseState from '../meta/CourseState'
import scrollToElement from '../services/Viewport/scrollToElement'

const STATES = {
    HIDDEN: 'is-hidden'
}

export default class CourseInstructions extends Component {

    prepare() {
        CourseState.on('change', this.handleStateChange)
        this.render(CourseState.state)
    }

    handleStateChange = state => {
        this.render(state)
    }

    render(state) {
        const completed = Object.entries(state.lessons)
            .map(entry => entry[1])
            .filter(lesson => lesson.completed)
            .length

        if (completed > 0) {
            this.hide()
        }
    }

    toggle() {
        if (this.is(STATES.HIDDEN)) {
            this.show()
        } else {
            this.hide()
        }
    }

    hide() {
        this.element.classList.add(STATES.HIDDEN)
    }

    show() {
        this.element.classList.remove(STATES.HIDDEN)
        scrollToElement(this.element, 80)
    }

}